var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var PrimetimeAds = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'PrimetimeAds'
  },

  getResource: function () {
    return this.resource
  },

  getTitle: function () {
    return 'unknown'
  },

  getDuration: function () {
    return this.duration
  },

  getPosition: function () {
    if (!this.plugin.getAdapter().flags.isJoined || this.plugin.getAdapter().getPlayhead() < 1) {
      return 'pre'
    } if (this.plugin.getAdapter().getPlayhead() === this.plugin.getAdapter().getDuration()) {
      return 'post'
    }
    return 'mid'
  },

  getPlayhead: function () {
    return ((this.player.currentTime - this.player.localTime) / 1000) - this.plugin.getAdapter().acumAdTime + this.duration
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    this.monitorPlayhead(true, false)

    var event = AdobePSDK.PSDKEventType
    // References
    this.references = []
    this.references[event.AD_BREAK_STARTED] = this.playListener.bind(this)
    this.references[event.AD_STARTED] = this.playListener.bind(this)
    this.references[event.AD_CLICK] = this.clickListener.bind(this)
    this.references[event.AD_BREAK_COMPLETED] = this.endedListener.bind(this)
    this.references[event.AD_BREAK_SKIPPED] = this.skippedListener.bind(this)
    this.references[event.AD_COMPLETED] = this.endedListener.bind(this)
    this.references[event.AD_PROGRESS] = this.progressListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  playListener: function (e) {
    this.fireStart()
  },

  endedListener: function (e) {
    this.fireStop({ adPlayhead: this.duration })
    this.duration = null
    this.initialPlayhead = null
    this.resource = null
  },

  skippedListener: function (e) {
    this.fireStop({ skipped: true })
    this.duration = null
    this.initialPlayhead = null
    this.resource = null
  },

  clickListener: function (e) {
    this.fireClick()
  },

  progressListener: function (e) {
    if (!this.flags.isJoined) {
      this.duration = e.ad.duration / 1000
      this.resource = e.ad.primaryAsset.resource.url
      this.plugin.getAdapter().acumAdTime += this.duration
      this.fireJoin()
    }
  }
})

module.exports = PrimetimeAds



//////////////////
// WEBPACK FOOTER
// ./src/ads/primetimeAds.js
// module id = 53
// module chunks = 0